import { render, staticRenderFns } from "./boxAttendees.vue?vue&type=template&id=2f56988c&scoped=true&"
import script from "./boxAttendees.vue?vue&type=script&lang=js&"
export * from "./boxAttendees.vue?vue&type=script&lang=js&"
import style0 from "./boxAttendees.vue?vue&type=style&index=0&id=2f56988c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f56988c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f56988c')) {
      api.createRecord('2f56988c', component.options)
    } else {
      api.reload('2f56988c', component.options)
    }
    module.hot.accept("./boxAttendees.vue?vue&type=template&id=2f56988c&scoped=true&", function () {
      api.rerender('2f56988c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/boxAttendees.vue"
export default component.exports